(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["umradata-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-umradata-sort] select').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  document.querySelectorAll('[data-umradata-country-search]').forEach((search) => {
    const root = search.closest('.umradata-collection');
    const input = search.querySelector('[data-umradata-country-input]');
    const clear = search.querySelector('[data-umradata-country-clear]');
    const cards = Array.from(root.querySelectorAll('[data-umradata-country-card]'));
    const empty = root.querySelector('[data-umradata-country-empty]');
    const normalize = (value) => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();

    const filterCountries = () => {
      const query = normalize(input.value);
      let visible = 0;

      cards.forEach((card) => {
        const matches = query === '' || normalize(card.textContent).includes(query);
        card.hidden = !matches;
        if (matches) visible += 1;
      });

      clear.hidden = query === '';
      empty.hidden = visible !== 0;
    };

    input.addEventListener('input', filterCountries);
    clear.addEventListener('click', () => {
      input.value = '';
      filterCountries();
      input.focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["umradata-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-umradata-product]').forEach((section) => {
    const variantId = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-variant-price]');
    const compare = section.querySelector('[data-variant-compare]');
    const addButton = section.querySelector('[data-add-button]');
    const addLabel = section.querySelector('[data-add-label]');
    const checkoutButton = section.querySelector('[data-direct-checkout]');
    const checkoutLabel = section.querySelector('[data-checkout-label]');
    const formError = section.querySelector('[data-form-error]');
    const quantityInput = section.querySelector('[data-quantity-input]');
    const bundleSummary = section.querySelector('[data-bundle-summary]');
    const bundleOriginal = section.querySelector('[data-bundle-original]');
    const bundleTotal = section.querySelector('[data-bundle-total]');
    const bundleSaved = section.querySelector('[data-bundle-saved]');
    const bundleDiscount = section.querySelector('[data-bundle-discount]');
    const upgradePrompt = section.querySelector('[data-upgrade-prompt]');
    const availableLabel = addLabel ? addLabel.textContent.trim() : '';
    const soldOutLabel = addButton ? addButton.dataset.soldOutLabel : '';

    const formatMoney = (cents) => {
      const number = cents / 100;
      const moneyFormat = section.dataset.moneyFormat;
      if (!moneyFormat) return '$' + number.toFixed(2);
      const token = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!token) return number.toFixed(2);
      let value = number.toFixed(2);
      if (token[1] === 'amount_no_decimals') value = Math.round(number).toString();
      if (token[1] === 'amount_with_comma_separator') value = value.replace('.', ',');
      if (token[1] === 'amount_no_decimals_with_comma_separator') value = Math.round(number).toString();
      return moneyFormat.replace(token[0], value).replace(/<[^>]*>/g, '');
    };

    const updateBundleSummary = () => {
      if (!bundleSummary || !bundleOriginal || !bundleTotal || !bundleSaved || !bundleDiscount) return;
      const selectedPlan = section.querySelector('input[type="radio"][data-price]:checked');
      const selectedQuantity = section.querySelector('[data-quantity-option]:checked');
      if (!selectedPlan || !selectedQuantity) return;
      const quantity = Number(selectedQuantity.value);
      if (quantity < 2) {
        bundleSummary.hidden = true;
        return;
      }
      const unitPrice = Number(selectedPlan.dataset.priceCents);
      const originalTotal = unitPrice * quantity;
      const discountRate = quantity >= 3 ? 0.10 : 0.05;
      const discountedTotal = Math.round(originalTotal * (1 - discountRate));
      const savings = originalTotal - discountedTotal;
      const percentage = quantity >= 3 ? bundleSummary.dataset.tenPercent : bundleSummary.dataset.fivePercent;
      bundleOriginal.textContent = formatMoney(originalTotal);
      bundleTotal.textContent = formatMoney(discountedTotal);
      bundleSaved.textContent = bundleSummary.dataset.savingTemplate.replace('__amount__', formatMoney(savings));
      bundleDiscount.textContent = bundleSummary.dataset.discountTemplate.replace('__percentage__', percentage);
      bundleSummary.hidden = false;
    };

    section.querySelectorAll('[data-quantity-option]').forEach((option) => {
      option.addEventListener('change', () => {
        if (!option.checked || !quantityInput || !addLabel || !addButton) return;
        quantityInput.value = option.value;
        if (addButton.disabled) return;
        if (option.value === '2') {
          addLabel.textContent = addButton.dataset.twoLabel;
        } else if (option.value === '3') {
          addLabel.textContent = addButton.dataset.threeLabel;
        } else {
          addLabel.textContent = addButton.dataset.singleLabel;
        }
        updateBundleSummary();
      });
    });

    if (upgradePrompt) {
      upgradePrompt.addEventListener('click', () => {
        const upgradeOption = section.querySelector(`input[data-price][value="${upgradePrompt.dataset.upgradeVariant}"]`);
        if (!upgradeOption || upgradeOption.disabled) return;
        upgradeOption.checked = true;
        upgradeOption.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    section.querySelectorAll('input[type="radio"][data-price]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        variantId.value = radio.value;
        price.textContent = radio.dataset.price;
        if (radio.dataset.compare) {
          compare.textContent = radio.dataset.compare;
          compare.hidden = false;
        } else {
          compare.textContent = '';
          compare.hidden = true;
        }
        const available = radio.dataset.available === 'true';
        addButton.disabled = !available;
        if (checkoutButton) checkoutButton.disabled = !available;
        if (upgradePrompt) upgradePrompt.hidden = radio.dataset.sku !== 'SA_1_7';
        if (available) {
          const selectedQuantity = section.querySelector('[data-quantity-option]:checked');
          if (selectedQuantity && selectedQuantity.value === '2') {
            addLabel.textContent = addButton.dataset.twoLabel;
          } else if (selectedQuantity && selectedQuantity.value === '3') {
            addLabel.textContent = addButton.dataset.threeLabel;
          } else {
            addLabel.textContent = availableLabel;
          }
        } else {
          addLabel.textContent = soldOutLabel;
        }
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', nextUrl);
        updateBundleSummary();
      });
    });

    if (checkoutButton && variantId && quantityInput) {
      checkoutButton.addEventListener('click', async () => {
        const originalLabel = section.dataset.checkoutLabel;
        addButton.disabled = true;
        checkoutButton.disabled = true;
        if (checkoutLabel) checkoutLabel.textContent = section.dataset.checkingOutLabel;
        if (formError) formError.hidden = true;

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: Number(variantId.value),
                quantity: Number(quantityInput.value || 1),
              }],
            }),
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || section.dataset.cartError);
          window.location.assign(`${window.Shopify.routes.root}checkout`);
        } catch (error) {
          if (formError) {
            formError.textContent = error.message || section.dataset.cartError;
            formError.hidden = false;
          }
          addButton.disabled = false;
          checkoutButton.disabled = false;
          if (checkoutLabel) checkoutLabel.textContent = originalLabel;
        }
      });
    }

    updateBundleSummary();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["umrah-bundle-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-umrah-bundle]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const quantityInput = root.querySelector('[data-bundle-quantity]');
      const bundleButtons = [...root.querySelectorAll('[data-bundle-choice]')];
      const planSelect = root.querySelector('[data-plan-select]');
      const planButtons = [...root.querySelectorAll('[data-plan-choice]')];
      const productForm = root.querySelector('.ub-lp__form');
      const buyButton = root.querySelector('[data-buy-button]');
      const buyLabel = root.querySelector('[data-buy-label]');
      const selectedTotals = [...root.querySelectorAll('[data-selected-total]')];
      const selectedSaving = root.querySelector('[data-selected-saving]');
      if (!quantityInput || !bundleButtons.length || !planSelect || !productForm) return;
      const currency = root.dataset.currency || 'USD';
      const locale = root.dataset.locale || 'en';
      const duoDiscount = Number(root.dataset.duoDiscount || 0);
      const groupDiscount = Number(root.dataset.groupDiscount || 0);
      const formatMoney = (cents) => new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
      const updatePrices = () => {
        const option = planSelect.options[planSelect.selectedIndex];
        const unitPrice = Number(option.dataset.price || 0);
        planButtons.forEach((button) => {
          const selected = String(button.dataset.planChoice) === String(planSelect.value);
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
        root.querySelectorAll('[data-bundle-price]').forEach((price) => {
          const quantity = Number(price.dataset.bundlePrice);
          const grossPrice = unitPrice * quantity;
          const discountPercent = quantity === 2 ? duoDiscount : quantity === 4 ? groupDiscount : 0;
          const bundlePrice = Math.round(grossPrice * (100 - discountPercent) / 100);
          price.textContent = formatMoney(bundlePrice);
          const comparePrice = root.querySelector(`[data-bundle-compare-price="${quantity}"]`);
          if (comparePrice) comparePrice.textContent = formatMoney(grossPrice);
          const saving = root.querySelector(`[data-bundle-saving="${quantity}"]`);
          if (saving) saving.textContent = `${saving.dataset.savingLabel} ${formatMoney(grossPrice - bundlePrice)} (${discountPercent}%)`;
        });
        const selectedQuantity = Number(quantityInput.value || 1);
        const selectedGrossPrice = unitPrice * selectedQuantity;
        const selectedDiscountPercent = selectedQuantity === 2 ? duoDiscount : selectedQuantity === 4 ? groupDiscount : 0;
        const selectedBundlePrice = Math.round(selectedGrossPrice * (100 - selectedDiscountPercent) / 100);
        selectedTotals.forEach((total) => {
          total.textContent = formatMoney(selectedBundlePrice);
        });
        if (selectedSaving) {
          const selectedSavingAmount = selectedGrossPrice - selectedBundlePrice;
          selectedSaving.hidden = selectedSavingAmount <= 0;
          selectedSaving.textContent = selectedSavingAmount > 0
            ? `${selectedSaving.dataset.savingLabel} ${formatMoney(selectedSavingAmount)} (${selectedDiscountPercent}%)`
            : '';
        }
        const available = option.dataset.available === 'true';
        if (buyButton) buyButton.disabled = !available;
        if (buyLabel) buyLabel.textContent = available ? buyLabel.dataset.availableLabel : buyLabel.dataset.soldOutLabel;
      };
      const chooseBundle = (quantity) => {
        quantityInput.value = quantity;
        bundleButtons.forEach((button) => {
          const selected = Number(button.dataset.bundleChoice) === Number(quantity);
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
        updatePrices();
      };
      planButtons.forEach((button) => button.addEventListener('click', () => {
        planSelect.value = button.dataset.planChoice;
        planSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      bundleButtons.forEach((button) => button.addEventListener('click', () => chooseBundle(button.dataset.bundleChoice)));
      root.querySelectorAll('[data-scroll-bundle]').forEach((button) => button.addEventListener('click', () => {
        chooseBundle(button.dataset.scrollBundle);
        root.querySelector('[id^="UmrahBundleOffer-"]').scrollIntoView({ behavior: 'smooth', block: 'center' });
      }));
      planSelect.addEventListener('change', updatePrices);
      quantityInput.addEventListener('change', updatePrices);
      productForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        const selectedOption = planSelect.options[planSelect.selectedIndex];
        if (!selectedOption || selectedOption.dataset.available !== 'true' || buyButton?.disabled) return;

        const shopRoot = window.Shopify?.routes?.root || '/';
        const availableLabel = buyLabel?.textContent || '';
        if (buyButton) {
          buyButton.disabled = true;
          buyButton.setAttribute('aria-busy', 'true');
        }

        try {
          const response = await fetch(`${shopRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: new FormData(productForm),
          });
          if (!response.ok) throw new Error('Unable to add the selected eSIM');
          window.location.assign(`${shopRoot}checkout`);
        } catch (error) {
          if (buyButton) {
            buyButton.disabled = false;
            buyButton.removeAttribute('aria-busy');
          }
          if (buyLabel) buyLabel.textContent = availableLabel;
          const variantId = encodeURIComponent(planSelect.value);
          const quantity = encodeURIComponent(quantityInput.value || '1');
          window.location.assign(`${shopRoot}cart/${variantId}:${quantity}?checkout`);
        }
      });
      updatePrices();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["umrah-product-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-umrah-landing]');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const form = root.querySelector('.ud-lp__product-form');
      if (!form) return;
      const planInputs = form.querySelectorAll('[data-variant-id]');
      const selectedVariantInput = form.querySelector('[data-selected-variant]');
      const addButton = form.querySelector('.ud-lp__add');
      const addLabel = form.querySelector('[data-add-label]');
      const checkoutButton = form.querySelector('[data-checkout]');
      const checkoutLabel = form.querySelector('[data-checkout-label]');
      const formError = form.querySelector('[data-form-error]');
      const quantityInput = form.querySelector('input[name="quantity"]');
      const quantityButtons = root.querySelectorAll('[data-quantity-choice]');
      const groupButtons = root.querySelectorAll('[data-group-quantity]');

      const selectPlan = (input) => {
        planInputs.forEach((item) => item.closest('.ud-lp__plan').classList.toggle('is-selected', item === input));
        selectedVariantInput.value = input.value;
        const available = input.dataset.variantAvailable === 'true';
        addButton.disabled = !available;
        checkoutButton.disabled = !available;
        addLabel.textContent = available ? root.dataset.addLabel : root.dataset.soldOutLabel;
        checkoutLabel.textContent = available ? root.dataset.checkoutLabel : root.dataset.soldOutLabel;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url);
      };

      const selectQuantity = (value) => {
        quantityInput.value = value;
        quantityButtons.forEach((button) => button.classList.toggle('is-selected', Number(button.dataset.quantityChoice) === Number(value)));
      };

      planInputs.forEach((input) => input.addEventListener('change', () => selectPlan(input)));
      quantityButtons.forEach((button) => button.addEventListener('click', () => selectQuantity(button.dataset.quantityChoice)));
      groupButtons.forEach((button) => button.addEventListener('click', () => {
        selectQuantity(button.dataset.groupQuantity);
        root.querySelector('[id^="UmrahPlans-"]').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }));

      const addSelectedPlan = async (destination) => {
        const selectedPlan = form.querySelector('[data-variant-id]:checked');
        if (!selectedPlan) return;

        addButton.disabled = true;
        checkoutButton.disabled = true;
        if (destination === 'checkout') {
          checkoutLabel.textContent = root.dataset.checkingOutLabel;
        } else {
          addLabel.textContent = root.dataset.addingLabel;
        }
        formError.hidden = true;

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: Number(selectedPlan.value),
                quantity: Number(quantityInput.value)
              }]
            })
          });

          const result = await response.json();
          if (!response.ok) throw new Error(result.description || root.dataset.cartError);
          window.location.assign(`${window.Shopify.routes.root}${destination}`);
        } catch (error) {
          formError.textContent = error.message || root.dataset.cartError;
          formError.hidden = false;
          addButton.disabled = false;
          checkoutButton.disabled = false;
          addLabel.textContent = root.dataset.addLabel;
          checkoutLabel.textContent = root.dataset.checkoutLabel;
        }
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        addSelectedPlan('cart');
      });
      checkoutButton.addEventListener('click', () => addSelectedPlan('checkout'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
